export type MinMaxRateValue = {
  From?: string,
  To?: string,
  Rate: string,
}[] | null;
